import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { UpdateOrderAssemblyStateInput } from './UpdateOrderAssemblyStateInput';
import { UpdateOrderAssemblyStateOutput } from './UpdateOrderAssemblyStateOutput';

export class UpdateOrderAssemblyStateService extends HttpServiceBase {

  handle = (input: UpdateOrderAssemblyStateInput): Promise<Result<UpdateOrderAssemblyStateOutput> | null> => {
    const promise = this.http.put<Result<UpdateOrderAssemblyStateOutput>, UpdateOrderAssemblyStateInput>(
      `${this.baseUrlSislogApi}/v2/order-assembly`,
      input
    );
    return promise;
  }
}